import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import AuthManager from "../../utils/AuthManager";

const IdleTimeoutContext = createContext();

// 閒置時間設定
const IDLE_TIMEOUT = 300 * 60 * 1000;

export const IdleTimeoutProvider = ({ children }) => {
  const [isIdleTimeout, setIsIdleTimeout] = useState(false);
  const idleTimerRef = useRef(null);

  // 重置閒置計時器
  const resetIdleTimer = () => {
    // 只有在已登入時才啟動計時器
    if (!AuthManager.isLoggedIn()) {
      return;
    }

    // 清除舊的計時器
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
    }

    // 設定新的計時器
    idleTimerRef.current = setTimeout(() => {
      console.log("⏰ 閒置逾時，觸發登出");
      setIsIdleTimeout(true);

      // 清除所有認證資料
      AuthManager.clearAllAuthData();
    }, IDLE_TIMEOUT);
  };

  // 清除計時器
  const stopIdleTimer = () => {
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
      idleTimerRef.current = null;
    }
  };

  // 重置逾時狀態
  const resetTimeoutState = () => {
    setIsIdleTimeout(false);
  };

  useEffect(() => {
    // 只有在已登入時才監控
    if (!AuthManager.isLoggedIn()) {
      return;
    }

    // 監聽的事件類型
    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
    ];

    // 初始啟動計時器
    resetIdleTimer();

    // 綁定事件監聽器
    events.forEach((event) => {
      document.addEventListener(event, resetIdleTimer, true);
    });

    // 清理函數
    return () => {
      //console.log("🛑 停止全域閒置逾時監控");
      events.forEach((event) => {
        document.removeEventListener(event, resetIdleTimer, true);
      });
      stopIdleTimer();
    };
  }, []);

  return (
    <IdleTimeoutContext.Provider
      value={{
        isIdleTimeout,
        resetTimeoutState,
        resetIdleTimer,
        stopIdleTimer,
      }}
    >
      {children}
    </IdleTimeoutContext.Provider>
  );
};

// 自定義 Hook
export const useIdleTimeout = () => {
  const context = useContext(IdleTimeoutContext);
  if (context === undefined) {
    throw new Error("useIdleTimeout must be used within IdleTimeoutProvider");
  }
  return context;
};

export default IdleTimeoutContext;
